import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { Utils } from '../../../../common/utils';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Filtering } from '../../../../service/filtering/filtering';
import { BaseView } from '../../../base-view';
import moment from 'moment';
import { TreeNode } from 'primeng/api';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { FertirrigacionEnvironmentDefinition } from './environment-variables';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { FertirrigacionFormDefinition } from './fertirrigacion-form/form-control/form-definition';
import { FertirrigacionModel } from 'src/app/models/tareas/fertirrigacion.model';

moment.locale('es');
@Component({
    selector: 'app-fertirrigacion',
    standalone: false,
    templateUrl: './fertirrigacion.component.html',
    styleUrls: ['./fertirrigacion.component.scss']
})
export class FertirrigacionComponent extends BaseView<FertirrigacionModel> implements OnInit, OnDestroy {
    public years = [
        { label: '...', value: 0 },
    ];

    public form: FertirrigacionFormDefinition | null = null;

    public env: FertirrigacionEnvironmentDefinition = new FertirrigacionEnvironmentDefinition();

    public hiddenButtonDelete = false;

    public showButtonDuplicate = true;

    public filter: Filtering<FertirrigacionModel> = new Filtering<FertirrigacionModel>();

    public getRequest: RequestHandler<FertirrigacionModel[]> = this.tareasApi.fertirrigacion.GET;

    public deleteRequest: RequestHandler<FertirrigacionModel> = this.tareasApi.fertirrigacion.DELETE;

    public pathToForm = 'crear-fertirrigacion';

    public menuItemId = 'fertirrigacion';

    public btnAnadir = 'Añadir Fertirrigación';

    public receta: FertirrigacionModel = {};

    public override canShow: Record<string, boolean> = {};

    public override model: FertirrigacionModel = {};

    public cols: ColInterface[] = [

        {
            field: 'cliente_nombre',
            header: this.env.clienteName,
            filter: '',
            visible: this.env.hasClients && this.env.userCanSeeClientes && !this.env.showTareasMto
        },
        {
            field: 'finca',
            header: this.env.fincaName
        },
        {
            field: 'sectores_nombres',
            header: this.env.sectoresName,
            visible: !this.env.showTareasMto
        },
        {
            field: 'parcelas_nombres',
            header: this.env.parcelasName,
            visible: !this.env.showTareasMto
        },
        {
            field: 'cultivo',
            header: 'Cultivo',
        },
        {
            field: 'fecha',
            header: 'Fecha',
        },
        {
            field: 'sistema_riego',
            header: 'Sistema Riego'
        },
        {
            field: 'dosis_riego',
            header: 'Dosis Riego',
        },
        {
            field: 'n_agua',
            header: 'N nítrico del agua',
        },
        {
            field: 'p205',
            header: 'P205 soluble en agua',
        },
        {
            field: 'aplicacion_residuos_r10',
            header: 'Aplicación de residuos R10',
        },
        {
            field: 'documento_aplicacion',
            header: 'Documento de Aplicación'
        },
    ];

    constructor(public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        public dashboard: DashboardService,
        private readonly router: Router
    ) {
        super(dashboardEvents, tareasApi.fertirrigacion.GET);
    }

    ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('fertirrigacion');
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<FertirrigacionModel>): string {
        const fertirrigacion = row.data as FertirrigacionModel;

        if (col.field === 'documento_aplicacion') {
            return fertirrigacion.documento_aplicacion === 1 ? 'Sí' : 'No'
        }

        return value;
    }

    public add(): void {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: FertirrigacionModel): void {
        this.router.navigate(['dashboard', 'editar-fertirrigacion', data.id, data]);
    }

    public duplicate(data: FertirrigacionModel): void {
        this.router.navigate(['dashboard', 'duplicar-fertirrigacion', data.id, data]);
    }


    public override show(modal: string, data: FertirrigacionModel): void {
        this.model = data;

        super.show(modal, this.model);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new FertirrigacionFormDefinition(formType, data as Record<string, string>, null);
    }

    public override hide(modal: string): void {
        this.model = {};
        this.canShow[modal] = false;
    }

    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.tareasApi.fertirrigacion.GET
        ]);
    }

    public downloadCsv(): void {
        this.form = new FertirrigacionFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Record<string, string>,
            null
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as FertirrigacionModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }
}
